import React from 'react';
import { useDispatch } from 'react-redux';
import Heading from '../../components/header';
import useApiLoadingOverlay from '../../hooks/useApiLoadingOverlay';
import useApiTopLoading from '../../hooks/useApiTopLoading';
import { actionNotifier } from '../../components/ui/toast';
import SiteCutOffContainer from '../../container/siteCutOffContainer';
import { useGetCutOffListQuery, useUpdateCutOffListMutation } from './cutOffApiSlice';

const getCutOffRows = (payload) => {
    if (Array.isArray(payload)) {
        return payload;
    }

    if (Array.isArray(payload?.data)) {
        return payload.data;
    }

    if (Array.isArray(payload?.rows)) {
        return payload.rows;
    }

    if (Array.isArray(payload?.data?.rows)) {
        return payload.data.rows;
    }

    return [];
};

const SiteCutOffPage = () => {
    const dispatch = useDispatch();

    const {
        data,
        isLoading,
        isFetching,
        refetch,
    } = useGetCutOffListQuery();

    const [updateCutOffList, { isLoading: isUpdating }] = useUpdateCutOffListMutation();

    const cutOffList = getCutOffRows(data);

    useApiTopLoading([isFetching], dispatch);
    useApiLoadingOverlay([isLoading, isUpdating], dispatch);

    const handleSave = async (payload) => {
        await updateCutOffList(payload).unwrap();
        actionNotifier.success('Cut off updated successfully.');
    };

    return (
        <>
            <Heading
                text="Cut Off"
                path="#"
                isFilterShow={false}
                isGraphShow={false}
            />
            <SiteCutOffContainer
                cutOffList={cutOffList}
                isLoading={isUpdating}
                onSave={handleSave}
                refetchCutOffList={refetch}
            />
        </>
    );
};

export default SiteCutOffPage;
